import {
  Syne_600SemiBold,
  Syne_700Bold,
  Syne_800ExtraBold,
} from '@expo-google-fonts/syne';
import {
  Outfit_400Regular,
  Outfit_500Medium,
  Outfit_600SemiBold,
  Outfit_700Bold,
} from '@expo-google-fonts/outfit';

export const APP_FONTS = {
  Syne_600SemiBold,
  Syne_700Bold,
  Syne_800ExtraBold,
  Outfit_400Regular,
  Outfit_500Medium,
  Outfit_600SemiBold,
  Outfit_700Bold,
};

export const APP_FONT_FAMILIES = {
  displaySemiBold: 'Syne_700Bold',
  displayBold: 'Syne_800ExtraBold',
  displayExtraBold: 'Syne_800ExtraBold',
  body: 'Outfit_400Regular',
  bodyMedium: 'Outfit_500Medium',
  bodySemiBold: 'Outfit_600SemiBold',
  bodyBold: 'Outfit_700Bold',
} as const;

type TextVariant =
  | 'default'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'p'
  | 'blockquote'
  | 'code'
  | 'lead'
  | 'large'
  | 'small'
  | 'muted'
  | null
  | undefined;

export function resolveWeightFont(className?: string) {
  if (!className) {
    return APP_FONT_FAMILIES.body;
  }

  if (className.includes('font-extrabold')) {
    return APP_FONT_FAMILIES.displayExtraBold;
  }

  if (className.includes('font-bold')) {
    return APP_FONT_FAMILIES.bodyBold;
  }

  if (className.includes('font-semibold')) {
    return APP_FONT_FAMILIES.bodySemiBold;
  }

  if (className.includes('font-medium')) {
    return APP_FONT_FAMILIES.bodyMedium;
  }

  return APP_FONT_FAMILIES.body;
}

export function resolveTextFontFamily(className?: string, variant?: TextVariant) {
  if (className && /font-(extra)?bold|font-semibold|font-medium/.test(className)) {
    return resolveWeightFont(className);
  }

  switch (variant) {
    case 'h1':
      return APP_FONT_FAMILIES.displayExtraBold;
    case 'h2':
      return APP_FONT_FAMILIES.displayBold;
    case 'h3':
    case 'h4':
    case 'large':
      return APP_FONT_FAMILIES.displaySemiBold;
    case 'small':
      return APP_FONT_FAMILIES.bodyMedium;
    default:
      return APP_FONT_FAMILIES.body;
  }
}
